import { FileCheck02, MessageChatCircle, Map01 } from '@untitled-ui/icons-react/build/cjs';
import { IWidget } from 'src/components/WidgetSettingsModal/widgetSettings.interface';
import { transformWidgets as _transformWidgets, WidgetTitleMap } from 'src/utils/widgetSettings.utils';

export type Widget = IWidget;

export const QUOTE_WIDGET_IDS = {
    MAP_IT: 'map-it',
    TERMS_AND_CONDITION: 'terms-and-condition',
    MESSAGES: 'messages',
} as const;

const QUOTE_WIDGET_TITLE_MAP: WidgetTitleMap = {
    [QUOTE_WIDGET_IDS.MAP_IT]: {
        title: 'Map It',
        description: 'View lane overview on the map',
        icon: Map01,
    },
    [QUOTE_WIDGET_IDS.TERMS_AND_CONDITION]: {
        title: 'Terms & Conditions',
        description: 'View terms and conditions for this quote',
        icon: FileCheck02,
    },
    [QUOTE_WIDGET_IDS.MESSAGES]: {
        title: 'Messages',
        description: 'View and send messages for this quote',
        icon: MessageChatCircle,
    },
};

// Default widget configuration — shown when the user has no saved settings yet
export const DEFAULT_QUOTE_WIDGET_SETTINGS: Record<string, { isEnabled: boolean; position: number }> = {
    [QUOTE_WIDGET_IDS.MAP_IT]: { isEnabled: true, position: 0 },
    [QUOTE_WIDGET_IDS.TERMS_AND_CONDITION]: { isEnabled: true, position: 1 },
    [QUOTE_WIDGET_IDS.MESSAGES]: { isEnabled: true, position: 2 },
};

export const transformQuoteWidgets = (widgetsData: any): Widget[] => _transformWidgets(widgetsData, QUOTE_WIDGET_TITLE_MAP);
